import request from '@/utils/request'

// 获取banner
export const GetBannerAPI = (data) => request.get('/banners/banner/', { params: data })

// 新增banner
export const AddBannerAPI = (data) => request.post('/banners/banner/', data)

// 获取banner详情
export const GetBannerDetailAPI = (id) => request.get(`/banners/banner/${id}/`)

// 更新banner信息
// export const PutBannerAPI = (data) => request.put(`/banners/banner/${data.id}/`, data)
export const PutBannerAPI = (data) => request({
  method: 'put',
  url: `/banners/banner/${data.get('id')}/`,
  data,
  headers: { 'Content-Type': 'multipart/form-data' }
})

// 删除banner信息
export const DelBannerAPI = (id) => request.delete(`/banners/banner/${id}/`)
